import { useDocumentVisibility } from '@vueuse/core'
import { sendMixpanelEvent, setProfileProperty } from '~/utils/host-browser-apis'

export const useTrackPageView = () => {
  if (process.client) {
    const activeTab = useDocumentVisibility()
    let reload = true
    watch(
      activeTab,
      async (current) => {
        if (current === 'visible' && reload) {
          await sendMixpanelEvent('NtpPage_Viewed')
          reload = false
        }
      },
      { immediate: true }
    )
  }

  onMounted(() => {
    setProfileProperty('ntp_url', location.hostname + location.pathname)
  })
}
